import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=aa805488&scoped=true&"
import script from "./ChatRoom.vue?vue&type=script&lang=js&"
export * from "./ChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=aa805488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa805488",
  null
  
)

export default component.exports